<div class="debug-drawer-card" role="region" aria-label="Debug drawer">
  <emperor-button
    class="debug-drawer-card-toggle-button"
    (click)="toggle()"
    [uiButtonType]="emperorButtonTypes.Text"
    [attr.aria-expanded]="isOpen()"
    aria-controls="debug-drawer-content"
  >
    <span class="toggle-text">
      @if (isOpen()) {
        Hide debug drawer
      } @else {
        Show debug drawer
      }
    </span>
  </emperor-button>

  <div
    id="debug-drawer-content"
    class="debug-drawer-card-content"
    [class.content-expanded]="isOpen()"
  >
    @if (isOpen()) {
      <mat-tab-group>
        <mat-tab label="Terminal">
          <app-terminal-debug-tab></app-terminal-debug-tab>
        </mat-tab>

        @if (hasApplicationForm()) {
          <mat-tab label="Application form">
            <app-application-form-debug-tab></app-application-form-debug-tab>
          </mat-tab>

          <mat-tab label="Quotes">
            <app-quotes-debug-tab></app-quotes-debug-tab>
          </mat-tab>
        }
      </mat-tab-group>
    }
  </div>
</div>
